import React from 'react';
import CommonLayout from '../leaked-private-photos/CommonLayout';
import LeakDetection from '../dmca-takedown-service/LeakDetection';

/**
 * DMCA Takedown Service 页面组件
 */
export default function RemoveLeakedOnlyfansContentNew({ data }: { data: any }) {
  // TopView 中的自定义内容
  const topViewContent = <LeakDetection />;

  // WhatDoView 中的自定义内容
  const whatDoViewContent = <LeakDetection />;

  return <CommonLayout data={data} topViewContent={topViewContent} whatDoViewContent={whatDoViewContent} />;
}
